module.exports = __webpack_public_path__ + "img/scrying-mirror-1.b6a32a4c.webp";